import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const usePlaceAvailabilityState = () => React.useContext(Context) || {}
export const usePlaceAvailability = () => usePlaceAvailabilityState()?.place

const QUERY = gql`
  query PlaceAvailabilityDetails($id: ID) {
    place(id: $id) {
      id
      name
      resume
      placeLevelsResume
      availabilityStatus
      availabilityStatusOrigin
      availabilityStatusChangedAt
      locks {
        id
        reason
        origin
        insertedAt
        createdBy {
          id
          name
        }
      }
    }
  }
`

const PlaceAvailabilityLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: placesClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PlaceAvailabilityLoader
